<template>
    <v-dialog v-model="dialog" persistent transition="scale-transition" max-width="600px">
        <v-card class="elevation-1">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click.native="handleModal">
                    <v-icon>fas fa-times-circle</v-icon>
                </v-btn>
                <v-toolbar-title>Detalle del abono</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row v-if="loading">
                    <v-col cols="12" class="text-center">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" sm="6">
                        <p><strong>Monto:</strong> {{ formatNumberToMoney(detalle.monto) }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <p><strong>Origen:</strong> {{ detalle.rayaDetalle ? 'Descuento de raya' : 'Abono directo' }}</p>
                    </v-col>
                    <v-col cols="12" sm="6" v-if="detalle.cashRegisterFolio">
                        <p><strong>Caja:</strong> {{ detalle.cashRegisterFolio }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <p><strong>Estatus:</strong>
                            <v-chip :color="detalle.eliminado ? 'error' : 'success'" label x-small dark
                                v-text="detalle.eliminado ? 'Cancelado' : 'Activo'">
                            </v-chip>
                        </p>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <p><strong>Registrado por:</strong> {{ detalle.createdByName }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <p><strong>Fecha de registro:</strong> {{ detalle.createdDateNatural }}</p>
                    </v-col>
                    <template v-if="detalle.eliminado">
                        <v-col cols="12" sm="6">
                            <p><strong>Cancelado por:</strong> {{ detalle.lastModifiedByName }}</p>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <p><strong>Fecha de cancelacion:</strong> {{ detalle.lastModifiedDateNatural }}</p>
                        </v-col>
                        <v-col cols="12">
                            <p><strong>Motivo de cancelacion:</strong> {{ detalle.catCancellationReasonName || 'N/A' }}</p>
                        </v-col>
                    </template>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import AbonoDeduccionDataService from '@/service/deduccion/AbonoDeduccionDataService';
import { getFormatCurrency } from '@/utils/CurrencyUtil';
import { extractMessage } from '@/helpers/errorHelper';

export default {
    name: "DetalleAbono",
    props: {
        dialog: { type: Boolean, default: false },
        handleModal: { type: Function },
        abonoSelected: { type: Object, default: () => ({}) }
    },
    created() {
        this.getDetalle();
    },
    data() {
        return {
            loading: false,
            detalle: {}
        }
    },
    methods: {
        getDetalle() {
            this.loading = true;
            AbonoDeduccionDataService.show(this.abonoSelected.id).then(resp => {
                this.detalle = resp.data;
            }).catch(err => {
                this.$swal.fire({ icon: 'error', title: 'Error al obtener el detalle', text: extractMessage(err), showConfirmButton: false, timer: 3000 });
            }).finally(() => this.loading = false);
        },
        formatNumberToMoney(number) {
            return getFormatCurrency(parseFloat(number) || 0, "$");
        }
    }
}
</script>
